module.exports = __webpack_public_path__ + "static/media/python.9ecfb672.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/python.svg
// module id = 67
// module chunks = 0